import { render, staticRenderFns } from "./IssueWaySection.vue?vue&type=template&id=7e59bf63&scoped=true&"
import script from "./IssueWaySection.vue?vue&type=script&lang=js&"
export * from "./IssueWaySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e59bf63",
  null
  
)

export default component.exports